import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractSpecificDataComponent } from 'src/app/components/declare-operation/operation-specific/abstract-specific-data.component';

@Component({
  selector: 'app-specific-data-conf27',
  standalone: false,
  templateUrl: './specific-data-conf27.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../specific-data-conf.common.scss'],
})
export class SpecificDataConf27Component extends AbstractSpecificDataComponent {
  @Input() override touchNonce?: number;
  override getDataName(): string {
    return 'specific-data-conf27';
  }
}
